import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions as measurementActions } from 'ducks/measurements';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectWiseButtons } from 'selectors/measurements';
import { metadataFields, serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';
import { getMeasurementMetadata } from 'utils/getMetadata.js';

const ActingMetal = props => {
    const { closeDrawer, device } = props;

    const wiseButtonsSelector = useMemo(() => selectWiseButtons(device?.root_device_id), [device?.root_device_id]);
    const wiseButtons = useSelector(wiseButtonsSelector);

    const measurement = useSelector(state => state.measurements.models[props.id]);
    const submitting = useSelector(state => state.measurements.submitting);

    const rootDevice = useSelector(state => state.devices.models[device.root_device_id]);
    const metadata = getMeasurementMetadata(device, rootDevice);

    const formSchema = [
        {
            type: 'text',
            label: 'Name\x2a',
            name: 'name',
            validate: [validators.required]
        },
        ...metadataFields(metadata, measurement),
        {
            allowBlank: true,
            formData: wiseButtons,
            label: 'WiseButton (only working for Montepio at the moment)',
            name: 'wise_button_id',
            type: 'select'
        }
    ];

    const update = measurementActions.useUpdate();
    const onSubmit = values => {
        update(
            measurement.id,
            serializeForm(values, formSchema, measurement),
            closeDrawer
        );
    };

    return (
        <FormViewer label="Edit Details">
            <Form
                formInitialValues={measurement}
                formSchema={formSchema}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default ActingMetal;
